jQuery(document).ready(function(){
    jQuery('.show-more-btn').click(function(){
        var target = jQuery(this).data('target');
        var textMore = jQuery(this).data('text-more');
        var textLess = jQuery(this).data('text-less');
        var $target = jQuery(target);

        $target.slideToggle(function(){
            if ($target.is(':visible')) {
                jQuery('.show-more-btn[data-target="' + target + '"]').text(textLess);
            } else {
                jQuery('.show-more-btn[data-target="' + target + '"]').text(textMore);
            }
        });
    });
});